import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <section className={styles.topicHeader}>
                <h1 className={styles.topicHeader_title}>{content.title}</h1>
                <p className={styles.topicHeader_intro}>{content.introduction}</p>
                <div className={styles.topicHeader_tag}>
                    {content.subTitle.map((item, index) => (
                        <a href={`#tag${index}`} key={index} className={styles.topicHeader_mark}>
                            {item}
                        </a>
                    ))}
                </div>
            </section>
        );
    }
}

export default errorBoundary(Banner);
